module.exports = __webpack_public_path__ + "img/icontitle_1.ab3ffcd2.png";